import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const b64urlToBytes = (v) => {
  const padded = v.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((v.length + 3) % 4);
  return Uint8Array.from(atob(padded), c => c.charCodeAt(0));
};

const bufToB64url = (buf) => {
  let s = '';
  new Uint8Array(buf).forEach(b => { s += String.fromCharCode(b); });
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const serialize = (cred) => {
  const r = cred.response;
  const common = {
    id: cred.id,
    rawId: bufToB64url(cred.rawId),
    type: cred.type,
    clientExtensionResults: cred.getClientExtensionResults(),
    authenticatorAttachment: cred.authenticatorAttachment,
  };
  if ('attestationObject' in r) {
    return { ...common, response: {
      clientDataJSON: bufToB64url(r.clientDataJSON),
      attestationObject: bufToB64url(r.attestationObject),
      transports: r.getTransports ? r.getTransports() : [],
    }};
  }
  return { ...common, response: {
    clientDataJSON: bufToB64url(r.clientDataJSON),
    authenticatorData: bufToB64url(r.authenticatorData),
    signature: bufToB64url(r.signature),
    userHandle: r.userHandle ? bufToB64url(r.userHandle) : null,
  }};
};

export const passkeysSupported = () => !!window.PublicKeyCredential;

export async function registerPasskey(headers) {
  const origin = window.location.origin;
  const { data } = await axios.post(`${API}/passkeys/register/options`, { origin }, { headers });
  const o = data.options;
  const publicKey = {
    ...o,
    challenge: b64urlToBytes(o.challenge),
    user: { ...o.user, id: b64urlToBytes(o.user.id) },
    excludeCredentials: (o.excludeCredentials || []).map(x => ({ ...x, id: b64urlToBytes(x.id) })),
  };
  const cred = await navigator.credentials.create({ publicKey });
  const res = await axios.post(`${API}/passkeys/register/verify`,
    { challenge_id: data.challenge_id, credential: serialize(cred), origin }, { headers });
  return res.data;
}

export async function loginWithPasskey() {
  const origin = window.location.origin;
  const { data } = await axios.post(`${API}/passkeys/login/options`, { origin });
  const o = data.options;
  const publicKey = {
    ...o,
    challenge: b64urlToBytes(o.challenge),
    allowCredentials: (o.allowCredentials || []).map(x => ({ ...x, id: b64urlToBytes(x.id) })),
  };
  const cred = await navigator.credentials.get({ publicKey });
  const res = await axios.post(`${API}/passkeys/login/verify`,
    { challenge_id: data.challenge_id, credential: serialize(cred), origin });
  return res.data;
}
